'use client';

import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import MarkdownContent from '@/components/ui/MarkdownContent';

const COOKIE_NAME = 'popover_dismissed';
const COOKIE_MAX_AGE = 60 * 60 * 24; // 1 dag

interface PopoverBannerProps {
	text: string;
}

const PopoverBanner = ({ text }: PopoverBannerProps) => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const dismissed = document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE_NAME}=`));
		if (!dismissed) setVisible(true);
	}, []);

	const dismiss = () => {
		document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
		setVisible(false);
	};

	if (!visible) return null;

	return (
		<div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50" data-nosnippet>
			<div className="relative bg-white rounded-md shadow-xl max-w-md w-full p-6">
				<button
					onClick={dismiss}
					aria-label="Sluiten"
					className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
				>
					<X className="size-5" />
				</button>
				<MarkdownContent content={text} className="prose max-w-none prose-headings:text-2xl prose-p:text-[18px] prose-headings:text-[#446084] prose-p:text-[#446084] prose-strong:text-[#446084]" />
				<button
					onClick={dismiss}
					className="mt-5 w-full bg-orange hover:bg-orange-hover text-white font-semibold py-2.5 rounded transition-colors"
				>
					Sluiten
				</button>
			</div>
		</div>
	);
};

export default PopoverBanner;
